import reservamosDevice from './reservamosDevice';
import getProductType from './getProductType';

const hasSentSearchEventKey = 'has-sent-search-event';
const hasSentTicketTypeEventKey = 'has-sent-ticket-type';

const MixpanelTracker = () => {
  let superPropsRegistered = false;

  const setUpMixPanelSuperProps = () => {
    const deviceFingerprint = reservamosDevice.getFingerprint();
    const mixpanelSuperProps = {
      product: getProductType(),
      ...(deviceFingerprint && { 'Device Fingerprint': deviceFingerprint }),
    };
    window.mixpanel.register(mixpanelSuperProps);
    superPropsRegistered = true;
  };

  // Register super props as soon as Mixpanel is available. Brands that load
  // Mixpanel late (e.g. via GTM) won't have it at module init, so we retry
  // lazily on the first tracked event instead of registering only once here.
  const ensureSuperProps = () => {
    if (!superPropsRegistered && window && window.mixpanel) {
      setUpMixPanelSuperProps();
    }
  };

  ensureSuperProps();

  const trackEvent = (eventName, properties) => {
    if (window && window.mixpanel) {
      ensureSuperProps();
      window.mixpanel.track(eventName, properties);
    }
  };

  const trackInterestInSearchEvent = properties => {
    const hasSentSearchEventWithSection = Boolean(
      sessionStorage.getItem(`${hasSentSearchEventKey}-${properties.section}`)
    );
    if (!hasSentSearchEventWithSection) {
      trackEvent('Interest in Search', properties);
      sessionStorage.setItem(`${hasSentSearchEventKey}-${properties.section}`, 'true');
    }
  };

  const trackInterestInTicketTypeEvent = properties => {
    const hasSentTicketTypeEventWithSection = Boolean(
      sessionStorage.getItem(`${hasSentTicketTypeEventKey}-${properties.section}`)
    );
    if (!hasSentTicketTypeEventWithSection) {
      trackEvent('Interest in Ticket Type', properties);
      sessionStorage.setItem(`${hasSentTicketTypeEventKey}-${properties.section}`, 'true');
    }
  };

  return {
    trackInterestInSearchEvent,
    trackInterestInTicketTypeEvent,
    trackEvent,
  };
};

const mixpanelTracker = MixpanelTracker();

export default mixpanelTracker;
